import { render } from "./VuePagoPlux.vue?vue&type=template&id=1f9833b7"
import script from "./VuePagoPlux.vue?vue&type=script&lang=js"
export * from "./VuePagoPlux.vue?vue&type=script&lang=js"

import "./VuePagoPlux.vue?vue&type=style&index=0&id=1f9833b7&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__